import React from 'react'
import { Field } from 'formik'

import { Select, NumberField } from '@/components/forms/formik'
import { LabelWithHelp } from '@/views/QACopilot/components/LabelWithHelp'

export const TimestampSilenceFields = ({ disabled }) => (
  <>
    <div className="copilot-prompt__additional-details">
      <div className="flex-align-center small-gap additional-details-holder">
        <LabelWithHelp
          label="Include Timestamps"
          help="Prefixes each transcript line with its time, e.g. [0:01:23]."
        />
        <Field
          name="include_timestamps"
          component={Select}
          options={[
            { value: 'true', label: 'Yes' },
            { value: 'false', label: 'No' },
          ]}
          disabled={disabled}
        />
      </div>
    </div>
    <div className="copilot-prompt__additional-details">
      <div className="flex-align-center small-gap additional-details-holder">
        <LabelWithHelp
          label="Flag Silences (seconds)"
          help="Inserts a marker like [Silence: 12 seconds] wherever there's a pause at least this long. Minimum 5; leave blank to turn off."
        />
        <Field
          placeholder="5 or more; blank to disable"
          name="silence_threshold_seconds"
          component={NumberField}
          disabled={disabled}
        />
      </div>
    </div>
  </>
)
